export const TOASTIFY_CLASS = 'Toastify';
